import type { DatasetsMutatorDeleteProps } from "./datasets-mutator-delete.type";

import DatasetsMutatorDeleteDataset from "../datasets-mutator-delete-dataset";
import { useDatasetMutatorGetDeleteItems } from "../datasets-mutator.hook";

const DatasetsMutatorDelete = ({
  onDatasetDelete,
  invalidate,
}: DatasetsMutatorDeleteProps) => {
  const { items, hasItems } = useDatasetMutatorGetDeleteItems();

  if (!hasItems) return null;

  return items.map((item) => (
    <DatasetsMutatorDeleteDataset
      key={item.mutationKey}
      mutatorItem={item}
      onDatasetDelete={onDatasetDelete}
      invalidate={invalidate}
    />
  ));
};

export default DatasetsMutatorDelete;
